import { useState } from 'react';
import type { OrderSide } from '@/analytics';
import type { MarketOptionDto } from '@/lib/models';
import type { BuyMarketContext } from './BuyInPopup';

/** The option being traded + the side the popup opens on. */
interface BuyTarget {
  option: MarketOptionDto;
  side: OrderSide;
}

/**
 * Owns the buy-in popup target for a single event page: which option/side is open,
 * the {@link BuyMarketContext} to feed {@link BuyInPopup}, and open/close handlers.
 * Shared by the binary and sports event pages so the popup wiring lives in one place.
 */
export function useBuyTarget(eventName: string): {
  market: BuyMarketContext | null;
  initialSide: OrderSide;
  onOpenBuy: (option: MarketOptionDto, side: OrderSide) => void;
  close: () => void;
} {
  const [target, setTarget] = useState<BuyTarget | null>(null);
  return {
    market: target ? { ...target.option, eventName } : null,
    initialSide: target?.side ?? 'yes',
    onOpenBuy: (option, side) => setTarget({ option, side }),
    close: () => setTarget(null),
  };
}
